import StudentQuizApi from './StudentQuizApi';
export default StudentQuizApi;
